import { useQuery } from '@tanstack/react-query';

import { api } from '@/services/api';
import { queryKeys } from '@/lib/queryKeys';
import type { PipelineStatusCounts } from '@/lib/dashboardApplicationBuckets';
import type { Period } from '@/hooks/useDashboardMetrics';

export type PipelineStatusCountsResponse = {
  period: Period;
  generatedAt: string;
  hasProcessingCredits: boolean;
  counts: PipelineStatusCounts;
  periodAppCount: number;
};

export function usePipelineStatusCountsQuery(
  companyId: string | undefined,
  period: Period,
  enabled = true,
) {
  return useQuery({
    queryKey: queryKeys.pipelineStatusCounts(companyId ?? '', period),
    queryFn: () => api.dashboard.pipelineStatusCounts(companyId!, period),
    enabled: !!companyId && enabled,
    staleTime: 60_000,
  });
}
